// Validate required environment variables
const requiredEnvVars = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  audience: import.meta.env.VITE_AUTH0_AUDIENCE,
};

// Check for missing environment variables
const missingVars = Object.entries(requiredEnvVars)
  .filter(([key, value]) => !value)
  .map(([key]) => `VITE_AUTH0_${key.toUpperCase()}`);

if (missingVars.length > 0) {
  const errorMessage = `Missing required environment variables: ${missingVars.join(', ')}`;
  console.error(errorMessage);
  throw new Error(errorMessage);
}

export const auth0Config = {
  domain: requiredEnvVars.domain!,
  clientId: requiredEnvVars.clientId!,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: requiredEnvVars.audience!,
    scope: "openid profile email",
  },
  cacheLocation: "localstorage" as const,
  useRefreshTokens: true,
};

// Debug logging for Auth0 configuration
console.log("Auth0 Configuration:", {
  domain: auth0Config.domain,
  clientId: auth0Config.clientId,
  audience: auth0Config.authorizationParams.audience,
  redirectUri: auth0Config.authorizationParams.redirect_uri,
  currentOrigin: window.location.origin,
});
